/**
 *
 * Home
 *
 */

import React, { memo, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

// styles
import './style.scss';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import saga from './saga';

import { flushStateHome, loadHome, changeHome, deleteHome } from './actions';

import {
  selectHomeData,
  selectHomeList,
  selectHomeLoading,
  selectHomeError,
  selectHomeDeleteSuccessful,
} from './selectors';

// antd component
import { Layout } from 'antd';
const { Content } = Layout;

// global user
import {
  withUser,
  useGetLocalUser,
  useGetLocalActiveChild,
} from 'engine/Contexts/User.context';
import { useAuthRole } from 'utils/hooks';

// components
import ButtonCardIcon from 'components/ButtonCardIcon';
import AddNewIconButton from 'components/AddNewIconButton';
// mobile components
import StudentInfo from 'mobile/components/StudentInfo';

export function Home({
  // main data
  homeList,
  homeData,
  // states
  deleteSuccessful,
  error,
  loading,
  history,
  user,
  roles,
  // actions
  loadHome,
  changeHome,
  flushState,
}) {
  useInjectReducer({ key: 'home', reducer });
  useInjectSaga({ key: 'home', saga });

  const localUser = useGetLocalUser()();
  const activeChild = useGetLocalActiveChild()();

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    // --> main code here

    // Anything in here is fired on component unmount.
    return () => {
      // Clearing the state after unmounting a component
      flushState();
    };
  }, []);

  return (
    <Layout className="main-full-content">
      <Helmet>
        <title>Home</title>
        <meta name="description" content="Description of Home" />
      </Helmet>
      <Content className="main-content-container home-page">
        {!!useAuthRole(['parent']) && (
          <AddNewIconButton
            className="float-add-communication"
            onClick={() => {
              history.push({
                pathname: `/communications/nouvel`,
                state: {
                  from: 'home',
                  goBack: '/home',
                  goBackTitle: 'Home',
                },
              });
            }}
          />
        )}

        <div className="control-btn-wrapper">
          <div className="box-btn absence">
            <h3 className="wrapper-title">Nouvelle absence</h3>
            <div className="wrapper-btn">
              <ButtonCardIcon
                //className="medical-btn"
                icon="medical"
                title="Médicale"
                action={() => {
                  history.push({
                    pathname: `/absences`,
                    state: {
                      openAbsence: 'medical',
                    },
                  });
                }}
              />
              <ButtonCardIcon
                //className="quill-btn"
                icon="quill"
                title="Non-médicale"
                action={() => {
                  history.push({
                    pathname: `/absences`,
                    state: {
                      openAbsence: 'no-medical',
                    },
                  });
                }}
              />

              <ButtonCardIcon
                //className="sickness-btn"
                icon="sickness"
                title="Maladie"
                action={() => {
                  history.push({
                    pathname: `/absences`,
                    state: {
                      openAbsence: 'sickness',
                    },
                  });
                }}
              />
            </div>
          </div>
          <div className="box-btn quick-links">
            <h3 className="wrapper-title">Liens rapides</h3>
            <div className="wrapper-btn">
              {!!useAuthRole(['parent']) && (
                <ButtonCardIcon
                  icon="absence-checked"
                  title="Présences"
                  action={() => {
                    history.push({
                      pathname: `/attendance`,
                    });
                  }}
                />
              )}
              <ButtonCardIcon
                icon="absence-active"
                title="Absences"
                action={() => {
                  history.push({
                    pathname: `/absences`,
                  });
                }}
              />

              <ButtonCardIcon
                icon="table"
                title="Agenda"
                action={() => {
                  history.push({
                    pathname: `/сours`,
                  });
                }}
              />

              {!!useAuthRole(['teacher']) && (
                <ButtonCardIcon
                  icon="letter-close"
                  title="News"
                  action={() => {
                    history.push({
                      pathname: `/communications`,
                    });
                  }}
                />
              )}

              {/* <ButtonCardIcon
                icon="school"
                title="École"
                action={handelClick} />
              <ButtonCardIcon
                icon="parameters"
                title="Paramètres"
                action={handelClick} />  */}
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
}

Home.propTypes = {
  dispatch: PropTypes.func.isRequired,
  flushState: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  deleteSuccessful: PropTypes.bool,
  loadHome: PropTypes.func.isRequired,
  changeHome: PropTypes.func,
  deleteHome: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  loading: selectHomeLoading(),
  error: selectHomeError(),
  deleteSuccessful: selectHomeDeleteSuccessful(),
  homeList: selectHomeList(),
  homeData: selectHomeData(),
});

function mapDispatchToProps(dispatch) {
  return {
    flushState: () => dispatch(flushStateHome()),
    loadHome: id => dispatch(loadHome(id)),
    changeHome: data => dispatch(changeHome(data)),
    deleteHome: id => dispatch(deleteHome(id)),
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  withUser,
)(Home);
